import { Link, useLocation, useNavigate } from "react-router-dom";

import { homeSvg } from "../assets/icons";
import { useTournamentStateContext } from "../data/providers/TournamentStateProvider";

function TournamentActionItems() {
  const { tournamentState, tournamentIdState } = useTournamentStateContext();
  const location = useLocation();
  const navigate = useNavigate();
  if (tournamentState.slug !== "") {
    sessionStorage.setItem("tournamentSlug", tournamentState.slug);
    sessionStorage.setItem("tournamentName", tournamentState.name);
  }
  const tournamentLink = `/tournaments/${tournamentIdState}/${sessionStorage.getItem("tournamentSlug")}`;
  const shouldShowAllTournamentLink = location.pathname !== "/tournaments";

  return (
    <section>
      {/* If there is an active tournament set */}
      {tournamentIdState !== 0 ? (
        <>
          <h3 className="BlueNavTitle">
            {sessionStorage.getItem("tournamentName")}
          </h3>
          <ul className="editMenu">
            <li className="editMenuItem">
              <button
                type="button"
                className="BlueNavOption"
                onClick={() => navigate(tournamentLink)}
              >
                <div className="homeItemWrapper">
                  Event Page
                  <img className="homeIcon" src={homeSvg} alt="Home" />
                </div>
              </button>
            </li>
          </ul>
        </>
      ) : (
        // If there is not a tournament
        <>
          <h3 className="BlueNavTitle">HCA Hope Fund</h3>
        </>
      )}

      {shouldShowAllTournamentLink && (
        <p className="BlueNavDiscreetText">
          <Link to="/tournaments">All Tournaments</Link>
        </p>
      )}
    </section>
  );
}

export default TournamentActionItems;
